/* ============================================================
   Holy Ice v2 — capa de interacción
   - Cursor propio (punto + anillo) con estados enlace/texto/arrastre
   - Botones magnéticos
   - Titulares que se revelan palabra a palabra
   - Reveal genérico [data-hv]
   - Tarjetas de producto: inclinación 3D, reflejo y destellos
   - Header: se esconde al bajar, vuelve al subir
   - Barra de progreso, volver arriba, veil de transición de página
   - Toast + rebote del contador al añadir al carrito
   Todo lo decorativo solo si <html> lleva .he-anim (lo pone theme.liquid
   salvo reduced-motion / Save-Data). Sin la clase, solo queda lo funcional
   (volver arriba, toast, header).
   ============================================================ */
(function () {
	"use strict";

	var html = document.documentElement;
	var ANIM = html.classList.contains("he-anim");
	var FINE = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
	var raf = window.requestAnimationFrame;
	// "Menos es más": efectos llamativos desactivados. Poner a true para recuperarlos.
	var HV_OPTS = { veil: false, cursor: false, sparks: false };

	function el(tag, cls, parent) {
		var n = document.createElement(tag);
		if (cls) n.className = cls;
		(parent || document.body).appendChild(n);
		return n;
	}

	/* ---------- 1. Progreso, header, volver arriba ---------- */
	var progressBar = el("div", "hv-progress");
	var header = document.querySelector(".js-header, .header");
	var ticking = false;

	var top = el("button", "hv-top");
	top.type = "button";
	top.setAttribute("aria-label", "Volver arriba");
	top.innerHTML =
		'<svg class="hv-top__ring" viewBox="0 0 100 100" aria-hidden="true"><circle cx="50" cy="50" r="49" pathLength="1"/></svg>' +
		'<svg class="hv-top__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
	top.addEventListener("click", function () {
		window.scrollTo({ top: 0, behavior: ANIM ? "smooth" : "auto" });
	});

	function onScroll() {
		var y = window.scrollY;
		var max = document.documentElement.scrollHeight - window.innerHeight;
		var p = max > 0 ? Math.min(1, Math.max(0, y / max)) : 0;
		html.style.setProperty("--he-progress", p.toFixed(4));
		top.classList.toggle("is-visible", y > 600);
		if (header) {
			header.classList.toggle("hv-header--scrolled", y > 40);
		}
		ticking = false;
	}
	window.addEventListener(
		"scroll",
		function () {
			if (!ticking) {
				ticking = true;
				raf(onScroll);
			}
		},
		{ passive: true }
	);
	onScroll();

	/* ---------- 2. Toast + contador ---------- */
	var toast = el("div", "hv-toast");
	toast.setAttribute("role", "status");
	var toastTimer;
	function showToast(msg) {
		toast.textContent = msg;
		toast.classList.add("is-on");
		clearTimeout(toastTimer);
		toastTimer = setTimeout(function () {
			toast.classList.remove("is-on");
		}, 2800);
	}
	window.holyToast = showToast;

	// Interceptamos fetch a /cart/add para saber cuándo se añade algo,
	// sin tocar el JS del carrito de Aurum.
	var origFetch = window.fetch;
	if (origFetch) {
		window.fetch = function (input, init) {
			var url = typeof input === "string" ? input : input && input.url;
			var p = origFetch.apply(this, arguments);
			if (url && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
				p.then(function (res) {
					if (res && res.ok) {
						showToast("Añadido a tu cesta");
						document.querySelectorAll(".header__cart-count").forEach(function (c) {
							c.classList.remove("hv-bump");
							void c.offsetWidth;
							c.classList.add("hv-bump");
						});
					}
				}).catch(function () {});
			}
			return p;
		};
	}

	/* ---------- 3. Veil de transición de página ---------- */
	var veil = HV_OPTS.veil ? el("div", "hv-veil") : null;
	if (ANIM && veil) {
		// La entrada la cubre el loader de marca (holy-loader); la veil solo
		// tapa la salida hacia la página siguiente.
		document.addEventListener("click", function (e) {
			var a = e.target.closest("a[href]");
			if (!a) return;
			if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
			if (a.target === "_blank" || a.hasAttribute("download") || a.getAttribute("href").charAt(0) === "#") return;
			var u;
			try {
				u = new URL(a.href, location.href);
			} catch (err) {
				return;
			}
			if (u.origin !== location.origin) return;
			if (u.pathname === location.pathname && u.search === location.search) return;
			if (/\.(jpg|jpeg|png|webp|gif|pdf|zip)$/i.test(u.pathname)) return;
			if (a.closest(".js-product-card-quick-view-button, [data-no-veil]")) return;
			e.preventDefault();
			veil.classList.add("is-on");
			setTimeout(function () {
				location.href = u.href;
			}, 520);
		});
		// Si el usuario vuelve con el botón atrás (bfcache), quitar la veil.
		window.addEventListener("pageshow", function (ev) {
			if (ev.persisted) veil.classList.remove("is-on");
		});
	}

	if (!ANIM) return;

	/* ---------- 4. Cursor propio ---------- */
	if (FINE && HV_OPTS.cursor) {
		var dot = el("div", "hv-cursor hv-cursor--dot is-hidden");
		var ring = el("div", "hv-cursor hv-cursor--ring is-hidden");
		var mx = -100, my = -100, rx = -100, ry = -100, shown = false;
		html.classList.add("hv-cursor-on");
		document.addEventListener(
			"mousemove",
			function (e) {
				mx = e.clientX;
				my = e.clientY;
				if (!shown) {
					shown = true;
					dot.classList.remove("is-hidden");
					ring.classList.remove("is-hidden");
				}
				var t = e.target;
				var link = t.closest && t.closest("a, button, [role=button], label, summary, .swiper-slide, .hc__card");
				var text = t.closest && t.closest("input:not([type=checkbox]):not([type=radio]), textarea, [contenteditable]");
				var drag = t.closest && t.closest("[data-hv-drag], .hc__stage, .swiper-container, .swiper");
				ring.classList.toggle("is-text", !!text);
				ring.classList.toggle("is-link", !!link && !text);
				ring.classList.toggle("is-drag", !!drag && !link && !text);
			},
			{ passive: true }
		);
		document.addEventListener("mouseleave", function () {
			dot.classList.add("is-hidden");
			ring.classList.add("is-hidden");
			shown = false;
		});
		var pressed = false;
		document.addEventListener("mousedown", function () { pressed = true; });
		document.addEventListener("mouseup", function () { pressed = false; });
		(function loop() {
			rx += (mx - rx) * 0.18;
			ry += (my - ry) * 0.18;
			dot.style.transform = "translate3d(" + mx + "px," + my + "px,0)";
			ring.style.transform = "translate3d(" + rx.toFixed(1) + "px," + ry.toFixed(1) + "px,0)" + (pressed ? " scale(0.8)" : "");
			raf(loop);
		})();
	}

	/* ---------- 5. Botones magnéticos ---------- */
	if (FINE) {
		document.addEventListener(
			"mousemove",
			function (e) {
				var b = e.target.closest && e.target.closest(".button, .hv-btn, .hv-top, .hc__arrow");
				if (!b) return;
				var r = b.getBoundingClientRect();
				var dx = (e.clientX - (r.left + r.width / 2)) / r.width;
				var dy = (e.clientY - (r.top + r.height / 2)) / r.height;
				b.style.transform = "translate(" + (dx * 8).toFixed(1) + "px," + (dy * 8).toFixed(1) + "px)";
				b.__hvMag = true;
			},
			{ passive: true }
		);
		document.addEventListener(
			"mouseout",
			function (e) {
				var b = e.target.closest && e.target.closest(".button, .hv-btn, .hv-top, .hc__arrow");
				if (b && b.__hvMag && !b.contains(e.relatedTarget)) {
					b.style.transform = "";
					b.__hvMag = false;
				}
			},
			{ passive: true }
		);
	}

	/* ---------- 6. Split de titulares + reveal genérico ---------- */
	var io = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (en) {
				if (!en.isIntersecting) return;
				en.target.classList.add(en.target.hasAttribute("data-hv-split") ? "hv-split-in" : "hv-in");
				io.unobserve(en.target);
			});
		},
		{ rootMargin: "-8% 0px", threshold: 0.05 }
	);

	function splitWords(node) {
		if (node.__hvSplit) return;
		node.__hvSplit = true;
		// Solo nodos de texto de primer nivel + <br>; conservamos hijos con
		// etiquetas (span dorado, etc.) como una "palabra" entera.
		var frag = document.createDocumentFragment();
		var i = 0;
		Array.prototype.slice.call(node.childNodes).forEach(function (child) {
			if (child.nodeType === 3) {
				child.textContent.split(/(\s+)/).forEach(function (piece) {
					if (!piece) return;
					if (/^\s+$/.test(piece)) {
						frag.appendChild(document.createTextNode(" "));
						return;
					}
					var w = document.createElement("span");
					w.className = "hv-w";
					var inner = document.createElement("span");
					inner.textContent = piece;
					inner.style.setProperty("--hv-d", (i++ * 0.06).toFixed(2) + "s");
					w.appendChild(inner);
					frag.appendChild(w);
				});
			} else if (child.nodeName === "BR") {
				frag.appendChild(child);
			} else {
				var w2 = document.createElement("span");
				w2.className = "hv-w";
				var inner2 = document.createElement("span");
				inner2.appendChild(child);
				inner2.style.setProperty("--hv-d", (i++ * 0.06).toFixed(2) + "s");
				w2.appendChild(inner2);
				frag.appendChild(w2);
			}
		});
		node.textContent = "";
		node.appendChild(frag);
	}

	var AUTO_SPLIT = [
		".hero-holy__title", ".hc__heading", ".hcat__heading", ".hcp__heading", ".hfq__heading",
		".hrv__heading", ".text-section__heading", ".image-with-text__heading", ".collection__title",
		".featured-products__heading", ".product-recommendations__heading", ".hbr__title",
		".hpf__title", ".newsletter__heading"
	];

	function decorate(root) {
		root.querySelectorAll("[data-hv-split], " + AUTO_SPLIT.join(", ")).forEach(function (h) {
			if (h.__hvSplit) return;
			if (h.closest(".hc__card, .product-card")) return;
			h.setAttribute("data-hv-split", "");
			splitWords(h);
			io.observe(h);
		});
		root.querySelectorAll("[data-hv]").forEach(function (n) {
			if (n.__hvObs) return;
			n.__hvObs = true;
			io.observe(n);
		});
		// Tarjetas de colección / recomendaciones: entrada escalonada por filas
		root.querySelectorAll(".collection__item:not([data-hv]), .product-recommendations__item:not([data-hv]), .featured-products__col:not([data-hv])").forEach(function (kid, i) {
			kid.setAttribute("data-hv", "up");
			kid.style.setProperty("--hv-d", ((i % 4) * 0.07).toFixed(2) + "s");
			kid.__hvObs = true;
			io.observe(kid);
		});
		// Stagger automático en grupos [data-hv-stagger] (hijos directos)
		root.querySelectorAll("[data-hv-stagger]").forEach(function (g) {
			if (g.__hvStag) return;
			g.__hvStag = true;
			var step = parseFloat(g.getAttribute("data-hv-stagger")) || 0.08;
			Array.prototype.forEach.call(g.children, function (kid, i) {
				if (!kid.hasAttribute("data-hv")) kid.setAttribute("data-hv", "up");
				kid.style.setProperty("--hv-d", (i * step).toFixed(2) + "s");
				if (!kid.__hvObs) {
					kid.__hvObs = true;
					io.observe(kid);
				}
			});
		});
	}
	decorate(document);
	new MutationObserver(function (muts) {
		muts.forEach(function (m) {
			m.addedNodes.forEach(function (n) {
				if (n.nodeType === 1) decorate(n);
			});
		});
	}).observe(document.body, { childList: true, subtree: true });

	/* ---------- 7. Tarjetas: tilt 3D, reflejo, destellos ---------- */
	if (FINE) {
		var sparkBudget = 0;
		document.addEventListener(
			"mousemove",
			function (e) {
				var card = e.target.closest && e.target.closest(".product-card");
				if (!card) return;
				var r = card.getBoundingClientRect();
				var px = (e.clientX - r.left) / r.width;
				var py = (e.clientY - r.top) / r.height;
				card.classList.add("hv-tilt");
				card.style.setProperty("--hv-ry", ((px - 0.5) * 10).toFixed(2) + "deg");
				card.style.setProperty("--hv-rx", ((0.5 - py) * 10).toFixed(2) + "deg");
				var wrap = card.querySelector(".product-card__image-wrapper");
				if (wrap) {
					var wr = wrap.getBoundingClientRect();
					wrap.style.setProperty("--hv-mx", ((e.clientX - wr.left) / wr.width * 100).toFixed(1) + "%");
					wrap.style.setProperty("--hv-my", ((e.clientY - wr.top) / wr.height * 100).toFixed(1) + "%");
					// Un destello cada ~90 ms mientras el ratón se mueve sobre la foto
					var now = performance.now();
					if (HV_OPTS.sparks && now - sparkBudget > 90 && e.target.closest(".product-card__image-wrapper")) {
						sparkBudget = now;
						var s = document.createElement("span");
						s.className = "hv-spark";
						s.style.setProperty("--x", (e.clientX - wr.left) + "px");
						s.style.setProperty("--y", (e.clientY - wr.top) + "px");
						s.style.setProperty("--dx", ((Math.random() - 0.5) * 40).toFixed(0) + "px");
						s.style.setProperty("--dy", (-20 - Math.random() * 30).toFixed(0) + "px");
						wrap.appendChild(s);
						setTimeout(function () { s.remove(); }, 850);
					}
				}
			},
			{ passive: true }
		);
		document.addEventListener(
			"mouseout",
			function (e) {
				var card = e.target.closest && e.target.closest(".product-card");
				if (card && !card.contains(e.relatedTarget)) {
					card.classList.remove("hv-tilt");
					card.style.removeProperty("--hv-rx");
					card.style.removeProperty("--hv-ry");
				}
			},
			{ passive: true }
		);
	}

	/* ---------- 8. Wordmark en el footer ---------- */
	var footer = document.querySelector(".footer");
	if (footer && !footer.querySelector(".hv-wordmark")) {
		var wm = document.createElement("div");
		wm.className = "hv-wordmark";
		wm.setAttribute("aria-hidden", "true");
		wm.textContent = "HOLY ICE";
		footer.insertBefore(wm, footer.firstChild);
	}
})();


/* Holy Ice — precios en formato español: "€1.234,56" → "1.234,56 €".
   El Liquid de las tarjetas y la ficha ya sale bien; esto cubre el carrito,
   los cajones y cualquier precio que pinte JavaScript o una app. */
(function () {
	var RX = /€\s?(\d{1,3}(?:\.\d{3})*(?:,\d{2})?)/g;
	function fix(root) {
		if (!root) return;
		var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
			acceptNode: function (n) {
				return n.nodeValue.indexOf('€') > -1 && !/SCRIPT|STYLE|TEXTAREA|INPUT/.test(n.parentNode && n.parentNode.nodeName)
					? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
			}
		});
		var n;
		while ((n = w.nextNode())) {
			var v = n.nodeValue.replace(RX, '$1\u00a0€');
			if (v !== n.nodeValue) n.nodeValue = v;
		}
	}
	function run() { fix(document.body); }
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
	var pending = [];
	new MutationObserver(function (list) {
		list.forEach(function (m) { pending.push(m.target.nodeType === 1 ? m.target : m.target.parentNode); });
		if (pending.length !== list.length) return; // ya hay un frame programado
		requestAnimationFrame(function () {
			var todo = pending; pending = [];
			todo.forEach(fix);
		});
	}).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
